<script>
    import MaterialRisk from '../Workspaces/ElementView/MaterialRisk.svelte';
    import ElementDetails from '../Workspaces/ElementView/ElementDetails.svelte';
    import KeyPointTable from '../Workspaces/ElementView/KeyPointTable.svelte';
    import QuestionsTable from '../Workspaces/ElementView/QuestionsTable.svelte';
    import HazardControlTable from '../Workspaces/ElementView/HazardControlTable.svelte';
    import ToolTable from '../Workspaces/ElementView/ToolTable.svelte';
    import PartTable from '../Workspaces/ElementView/PartTable.svelte';
    import Section from '../common/Section.svelte';
    import {sgettext} from '../../i18n.js';
    import CorrectiveAction from '../Element/CorrectiveAction.svelte';
    import ReferenceDocumentTable from '../Workspaces/ElementView/ReferenceDocumentTable.svelte';
    import {
        readOnly
    } from './diffStore.js';

    export let count;
    export let countTarget;
    export let elementDetails = null;
    export let elementTargetDetails = null;
    export let sourceTemplateVersionNumber = 0;
    export let targetTemplateVersionNumber = 0;
    export let sourceTemplateStatus = "";
    export let targetTemplateStatus = "";
    export let showContextualFields = false;

</script>

{#if elementDetails != null && elementTargetDetails != null}
  <div class="wrapper">
    {#each [elementDetails, elementTargetDetails] as element}
      {#if element?.materialRisk}
        <div class="details-column">
          <MaterialRisk
            mechanism={element.materialRisk.mechanism}
            hazard={element.materialRisk.hazard}
            control={element.materialRisk.control}
            valid={element.materialRisk.valid}
          />
        </div>
      {/if}
    {/each}
  </div>

  <div class="wrapper">
    {#each [[elementDetails, count, sourceTemplateStatus, sourceTemplateVersionNumber], [elementTargetDetails, countTarget, targetTemplateStatus, targetTemplateVersionNumber]] as [details, detailsCount, templateStatus, templateVersionNumber], isFirstElement}
      <div class="details-column">
        <ElementDetails
          count={detailsCount}
          {details}
          linkToEV={true}
          showVersions={false}
          contextualReadOnly={true}
          diffView={true}
          {readOnly}
          workspaceReadOnly={readOnly}
          status={templateStatus}
          {templateStatus}
          {templateVersionNumber}
          leftSide={isFirstElement === 0}
          {showContextualFields}
        />
      </div>
    {/each}
  </div>

  <div class="wrapper">
    {#each [elementDetails?.hazardscontrols, elementTargetDetails?.hazardscontrols] as hazardscontrols}
      {#if hazardscontrols}
        <div class="details-column">
          <Section title={sgettext('$$RISKS_CONTROLS_1$$')}>
            <HazardControlTable rows={hazardscontrols} />
          </Section>
        </div>
      {/if}
    {/each}
  </div>

  <div class="wrapper">
    {#each [elementDetails, elementTargetDetails] as element}
      {#if element && (element.type === 'QUALITY' || element.type === 'SAFETY' || element.type === 'KNACK')}
        <div class="details-column">
          <Section title={sgettext('$$KEY_POINTS$$')}>
            <KeyPointTable rows={element.keypoints} />
          </Section>
        </div>
      {/if}
    {/each}
  </div>

  <div class="wrapper">
    {#each [elementDetails, elementTargetDetails] as element}
      {#if element && (element.type === 'QUALITY' || element.type === 'SAFETY')}
        <div class="details-column">
          <Section title={sgettext('$$QUESTIONS$$')}>
            <QuestionsTable rows={element.questions} />
          </Section>
        </div>
      {/if}
    {/each}
  </div>

  <div class="wrapper">
    {#each [elementDetails, elementTargetDetails] as model}
      <div class="details-column">
        <Section title={sgettext('$$CORRECTIVE_ACTION$$')}>
          <CorrectiveAction {model} />
        </Section>
      </div>
    {/each}
  </div>

  <div class="wrapper">
    {#each [elementDetails, elementTargetDetails] as element}
      {#if element?.type === 'TOOL'}
        <div class="details-column">
          <Section title={sgettext('$$TOOLS$$')}>
            <ToolTable rows={element.tools} />
          </Section>
        </div>
      {/if}
    {/each}
  </div>

  <div class="wrapper">
    {#each [elementDetails, elementTargetDetails] as element}
      {#if element?.type === 'PART'}
        <div class="details-column">
          <Section title={sgettext('$$PARTS$$')}>
            <PartTable rows={element.parts} />
          </Section>
        </div>
      {/if}
    {/each}
  </div>

  <div class="wrapper">
    {#each [elementDetails, elementTargetDetails] as element}
      <div class="details-column">
        <Section title={sgettext('$$REFERENCE_DOCUMENTS$$')}>
          <ReferenceDocumentTable rows={element.reference_documents} />
        </Section>
      </div>
    {/each}
  </div>
  <br />
{/if}

<style>
  .wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    width: 100%;
    padding: 0 15px;
  }

  .details-column:nth-child(2) {
    border-left: 2px solid #9fa6ab;
    padding-left: 15px;
  }

  .details-column {
    /* No specific width needed here, as the wrapper grid definition will control the column sizing */
  }

  table {
    width: 100%;
  }

  th {
    vertical-align: top;
  }

  @media (max-width: 1600px) {
    .wrapper {
      grid-template-columns: 1fr; /* Stack the columns vertically on smaller screens */
    }
    .details-column:nth-child(2) {
      border-left: none; /* Ignore border if stacked */
    }
  }

  .wrapper > section {
    min-height: 150px;
    margin: 15px 5px;
  }
</style>
